"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = undefined;

var _dec, _class;

require("source-map-support/register");

var _uuid = require("uuid");

var uuidv4 = _uuid.v4;

var _tsyringe = require("tsyringe");

var singleton = _tsyringe.singleton;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var UUID = (_dec = singleton(), _dec(_class = /*#__PURE__*/function () {
  function UUID() {
    _classCallCheck(this, UUID);
  }

  _createClass(UUID, [{
    key: "getV4",
    value: function getV4() {
      return uuidv4();
    }
  }]);

  return UUID;
}()) || _class);
exports["default"] = UUID;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9IZWxwZXIvVVVJRC50cyJdLCJuYW1lcyI6WyJ1dWlkdjQiLCJ2NCIsInNpbmdsZXRvbiIsIlVVSUQiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7O0FBQUE7O0lBQWVBLE0sU0FBTkMsRTs7QUFDVDs7SUFBU0MsUyxhQUFBQSxTOzs7Ozs7OztJQUdZQyxJLFdBRHBCRCxTQUFTLEU7Ozs7Ozs7NEJBRVE7QUFDZCxhQUFPRixNQUFNLEVBQWI7QUFDRDs7Ozs7cUJBSGtCRyxJIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgdjQgYXMgdXVpZHY0IH0gZnJvbSAndXVpZCc7XG5pbXBvcnQgeyBzaW5nbGV0b24gfSBmcm9tICd0c3lyaW5nZSc7XG5cbkBzaW5nbGV0b24oKVxuZXhwb3J0IGRlZmF1bHQgY2xhc3MgVVVJRCB7XG4gIGdldFY0KCk6IHN0cmluZyB7XG4gICAgcmV0dXJuIHV1aWR2NCgpO1xuICB9XG59XG4iXX0=